(function (angular) {
	'use strict';

	angular
		.module('modalModule')
		.directive('modal', [
			'$window',
			'mixpanelFactory',
			'STATIC_BASE_PATH',
			modalFunction
		]);

	function modalFunction(
		$window,
		mixpanelFactory,
		STATIC_BASE_PATH
	) {	
		return {
			restrict: 'E',
			scope: {
				active: '=',
				closeCallback: '&?',
				title: '@?',
				excludeCloseButton: '@?'
			},
			transclude: true,
			replace: true,
			templateUrl: STATIC_BASE_PATH + '/static/html/shared/modal/modal.directive.html',
			link: function ($scope, $elem, $attrs) {
				$scope.dismiss = function() {
					$scope.active = false;
					$scope.shown = false;

					if(angular.isDefined($scope.closeCallback)) {
						$scope.closeCallback();
					}
				};

				$scope.$watch('active', function() {
					if($scope.active === $attrs.id) {
						$scope.shown = true;
						
						mixpanelFactory.track('Modal Viewed', {
							'ID' : $scope.active
						});
					} else {
						$scope.shown = false;
					}
				});
			}
		};
	}
})(window.angular);